<dx-tab-panel [dataSource]="pages"
              [selectedIndex]="0"
              class="p-2 np-inner-tab-panel"
              [showNavButtons]="true"
              [scrollingEnabled]="true"
              [scrollByContent]="false"
              [swipeEnabled]="false"
              style="height: 100%;"
              (onSelectionChanged)="onSelectionChanged($event)">
  <div *dxTemplate="let company of 'priceListTemplate'">
    <catalogPriceList *ngIf="model"></catalogPriceList>
  </div>
  <div *dxTemplate="let company of 'classificationTemplate'">
    <catalogClassification></catalogClassification>
  </div>
  <div *dxTemplate="let company of 'osgTemplate'">
    <catalogOsg></catalogOsg>
  </div>
  <div *dxTemplate="let company of 'printTemplate'">
    <catalogPrint></catalogPrint>
  </div>
  <div *dxTemplate="let company of 'shopware6Template'">
    <catalogShopware6></catalogShopware6>
  </div>
  <div *dxTemplate="let company of 'shopware5Template'">
    <catalogShopware5></catalogShopware5>
  </div>
  <div *dxTemplate="let company of 'intershopTemplate'">
    <intershopConnection></intershopConnection>
  </div>
  <div *dxTemplate="let company of 'electronicSalesTemplate'">
    <electronicSalesConnection></electronicSalesConnection>
  </div>
  <div *dxTemplate="let company of 'foresightTemplate'">
    <foresightConnection></foresightConnection>
  </div>
  <div *dxTemplate="let company of 'refenenceSourcesTemplate'">
    <np-catalog-reference-sources/>
  </div>
  <div *dxTemplate="let company of 'dataSourceMappingTemplate'">
    <catalog-data-source-mapping/>
  </div>
  <div *dxTemplate="let company of 'gevisTemplate'">
    <gevis></gevis>
  </div>
  <div *dxTemplate="let company of 'odooTemplate'">
    <odoo></odoo>
  </div>
  <div *dxTemplate="let company of 'exportTemplate'">
    <catalogExport></catalogExport>
  </div>


  <!--JOBS-->
  <div *dxTemplate="let job of 'jobsTemplate'">
    <job-list [storeName]="'JobListStateNewUI_V4_CATALOGDETAIL'"
              [jobListMode]="false"
              [catalogMode]="true"
              [adminMode]="false">
      <!-- always choose ONE mode!! -->
    </job-list>
  </div>
</dx-tab-panel>
